/** Where the frontend's sign-in page is, which the server sends the browser back to. */
export const SIGN_IN_PATH = "/sign-in";

/**
 * The `error` the server sends the browser back to the sign-in page with when
 * a sign-in fails, for whatever reason. One value for every failure, so the
 * address bar cannot be used to learn whether an account exists.
 */
export const SIGN_IN_FAILED = "sign_in_failed";
